<template>
  <div>
    <div class="topHeader app">
      <img src="/static/img/index/back.png" alt="" class="backImg" @click="goBack()" />
      <div class="title">
        <!-- 银行卡付款 -->
        {{$t('bankList.bankCardPay')}}
      </div>
    </div>
    <div class="payInfo">
      <div class="money">{{$t('public.money')}}<span>{{totalPrice | filterMoney}}</span></div>
      <div class="name">
        {{$t('bankList.payName')}}
        <!-- 商户名称 北京擘盒科技有限公司 -->
      </div>

    </div>
    <div class="bankListCon">
      <div class="title">
        <span>{{$t('bankList.chooseBank')}}</span>
        <span class="sale" v-if="bankPaySaleObj.status">最多可减免{{bankPaySaleObj.max/100}}元</span>
        <!-- 选择银行卡 -->
      </div>
      <div class="bankCon">
        <div class="list" v-for="(item,index) in bankList" :key="index" @click="changeOn(item.check,item.id)">
          <img :src="item.banklogo" alt="" class="banklogo">
          <div class="name"> {{item.bankname}}（{{item.cardno}}）</div>
          <img src="/static/img/payment/select-check.png" alt="" class="selectImg" v-if="item.check">
          <img src="/static/img/payment/select-off.png" alt="" class="selectImg" v-else>
        </div>
        <div class="list" @click="addBank()">
          <div class="name">
            {{$t('bankList.addBank')}}
            <!-- 添加银行卡 -->
          </div>
          <img src="/static/img/payment/next.png" alt="" class="nextImg">
        </div>
      </div>
      <div class="time" v-if="false">
        {{$t('bankList.please')}}
        <!-- 请在 -->
        <span>{{payCountDown}}</span>
        <!-- 内完成支付 -->
        {{$t('bankList.complatedPay')}}
      </div>
      <div class="payment_btn" @click="goPay()">
        <!-- 去支付 -->
        {{$t('bankList.goPay')}}<template v-if="payCountDown">({{payCountDown}})</template>
      </div>
    </div>
    <!-- 未设置支付密码弹窗 -->
    <!-- 请先设置支付密码 -->
    <!-- 取消 -->
    <!-- 去设置 -->
    <d-confirm v-model="pwdmodal" :content="$t('bankList.setPwd')" :ok-text="$t('bankList.confirm')"
      :cancel-text=" $t('bankList.goSet')" ok-color="#f5f5f9" cancel-color="#1ce89e" @on-ok="pwdmodal = false "
      @on-cancel="handleok">
    </d-confirm>
    <!-- 您是否已完成本次支付？ -->
    <!-- 未支付 -->
    <!-- 我已支付 -->
    <d-confirm v-model="payResultModal" :loading="payResult" :content="$t('bankList.isComplatePay')"
      :ok-text="$t('bankList.noPay')" :cancel-text="$t('bankList.isPay')" ok-color="#f5f5f9" cancel-color="#1ce89e"
      @on-ok="payResultErrorFn" @on-cancel="payResultSuccess">
    </d-confirm>

    <!-- 输入验证码 -->
    <div class="setPassAlertMask" v-if="isShowPassWordAlert">
      <div class="passwordModel">
        <div class="close" @click="passClose"></div>
        <p class="pass-title">{{yzmTitle}}</p>
        <div class="captcha">
          <input v-for="(c, index) in ct" :key="index" type="number" v-model.number="ct[index]" ref="input"
            :style="{borderBottomColor: index <= cIndex ? '#333' : ''}" @input="e => {onInput(e.target.value, index)}"
            @keydown.delete="e=>{onKeydown(e.target.value, index)}" @focus="onFocus" :disabled="loading">
        </div>
        <div class="modelBtn" v-if="!isComplate2">{{payBtnText}}</div>
        <div class="modelBtn1" v-else @click="payconfirm">{{payBtnText}}</div>
      </div>
    </div>

  </div>
</template>
<script>
  var int1
  var int
  export default {
    data() {
      return {
        bindBankNo: '',
        yzmTitle: '输入支付验证码', //输入绑卡验证码
        payBtnText: '确认支付', //支付， 绑卡
        isBindOrPay: 'pay', // bind

        payToken: '', // 易宝银行卡支付需要的token
        payResult: false,
        payResultModal: false, //支付成功失败弹窗
        payResultError: 0, // 支付失败结果展示前提条件，状态接口轮询查询，int++ ，当值为5时提示支付失败
        pwdmodal: false, //设置支付密码弹窗
        bankList: [],
        totalPrice: "",
        payCountDown: "", //支付倒计时
        timer: null,
        bankid: "",
        callbackurl: "",
        orderno: "",
        source: "",
        type: "",
        id: "",
        status: "",
        pwdmodalData: {},
        pwdUrl: "",
        bankPaySaleObj: { // 银行卡见面规则展示
          max: '',
          min: '',
          status: false,
        },

        ct: ['', '', '', '', '', ''],
        isShowPassWordAlert: false,
        isComplate2: false,
        loading: false,
        orderStatusSetTimeout: null,
        CURRENTTIME: Date.now(),
        isInApp: false
      }
    },
    computed: {
      ctSize() {
        return this.ct.length;
      },
      cIndex() {
        let i = this.ct.findIndex(item => item === '');
        i = (i + this.ctSize) % this.ctSize;
        return i;
      },
      lastCode() {
        return this.ct[this.ctSize - 1];
      }
    },
    filters: {
      //分转元
      filterMoney(num) {
        return (num / 100).toFixed(2);
      },
      subStr(num) {
        return num.substring(0, 1);
      },
    },
    watch: {
      cIndex() {
        this.resetCaret();
      },
      lastCode(val) {
        console.log(val, 'this.ctSize', this.ctSize)
        if (val) {
          this.$refs.input[this.ctSize - 1].blur();
          this.isComplate2 = true;
        } else {
          this.isComplate2 = false;
        }
      },
    },
    methods: {
      reset() {
        // 重置。一般是验证码错误时触发。
        this.ct = this.ct.map(item => '');
        this.resetCaret();
        this.loading = false;
      },
      onInput(val, index) {
        this.msg = ''
        val = val.replace(/\s/g, '');
        console.log(val)
        if (index == this.ctSize - 1) {
          this.ct[this.ctSize - 1] = val[0]; // 最后一个码，只允许输入一个字符。
        } else if (val.length > 1) {
          let i = index;
          for (i = index; i < this.ctSize && i - index < val.length; i++) {
            this.ct[i] = val[i];
          }
          this.resetCaret();
        }
      },
      // 重置光标位置。
      resetCaret() {
        this.$refs.input[this.ctSize - 1].focus();
      },
      onFocus() {
        // 监听 focus 事件，将光标重定位到“第一个空白符的位置”。
        let index = this.ct.findIndex(item => item === '');
        index = (index + this.ctSize) % this.ctSize;
        // console.log(this.$refs.input)
        this.$refs.input[index].focus();
      },
      onKeydown(val, index) {
        if (val === '') {
          // 删除上一个input里的值，并对其focus。
          if (index > 0) {
            this.ct[index - 1] = '';
            this.$refs.input[index - 1].focus();
          }
        }
      },
      passClose() {
        this.ct = ['', '', '', '', '', ''];
        this.isShowPassWordAlert = false;
      },
      // 用户点击支付成功按钮
      payResultSuccess() {
        this.$toast({
          message: this.$i18nn.t('bankList.payStatus'),
        });
        // "支付中，请耐心等待！"
        // that.$toast({
        //     message: that.$i18nn.t('addBank.InCardPhone'),
        //   });
        if (this.type == 1) {
          this.pay_statusBox()
        } else if (this.type == 2) {
          this.pay_statusWork()
        } else if (this.type == 4) {
          this.orderStatus(4)
        }

        if (this.source.indexOf('boheSuger') != -1) {
          this.orderStatus()
        }
      },
      // 用户选择未支付，也主动查询订单结果
      payResultErrorFn() {
        if (this.type == 1) {
          this.pay_statusBox()
        } else if (this.type == 2) {
          this.pay_statusWork()
        } else if (this.type == 4) {
          this.orderStatus(4)
        }
        if (this.source.indexOf('boheSuger') != -1) {
          this.orderStatus()
        }
      },
      //去设置支付密码
      handleok() {
        let that = this;
        window.location.href = that.pwdUrl + "?Address=" +
          location.origin + "/appBankList?backstring=" +
          JSON
          .stringify(that.pwdmodalData)
      },
      //查询订单状态  盲盒支付
      pay_statusBox() {
        let that = this;
        that.orderStatus(1)
      },
      //pay_statusWork  查询订单状态  作品支付
      pay_statusWork() {
        let that = this;
        that.orderStatus(2)
      },
      changeOn(check, id) {
        console.log(id)
        let that = this;
        that.bankid = id
        that.bankList.forEach(item => {
          item.check = false
          if (id == item.id) {
            item.check = true;
            that.id = item.id
          }
        });
      },

      goBack() {
        if (this.$route.query.backstring) {
          let data = JSON.parse(this.$route.query.backstring)
          this.$router.push({
            path: data.source || '/payment',
            query: {
              orderno: data.orderno,
              source: data.source,
              type: data.ordertype || data.type,
              id: data.id,
              status: data.status,
              boxSource: data.boxSource,
            }
          })
        } else if (this.$route.query.orderdata) {
          //去 宝付后的回调
          let data = JSON.parse(this.$route.query.orderdata)
          this.$router.push({
            path: data.source || '/payment',
            query: {
              orderno: data.orderno,
              type: data.ordertype || data.type,
              source: data.source,
              id: data.id,
              status: data.status,
              boxSource: data.boxSource,
            }
          })
        } else {
          this.$router.push({
            path: this.$route.query.source || '/payment',
            query: {
              orderno: this.$route.query.orderno,
              type: this.$route.query.ordertype || this.$route.query.type,
              source: this.$route.query.source,
              id: this.$route.query.id,
              status: this.$route.query.status,
              boxSource: this.$route.query.boxSource,
            }
          })
        }
        clearInterval(this.timer);
        window.clearInterval(int);
        window.clearInterval(int1);
      },

      banklist() {
        let that = this;
        that.$fetchql.Post("bank/list").then((res) => {
          if (res.code == 0 && res.data.length) {
            res.data.forEach(item => {
              item.check = false
            });
            res.data[0].check = true
            that.bankList = res.data
            that.bankid = res.data[0].id
          }
        })
      },
      payconfirm() {
        if (this.isBindOrPay == 'pay') {
          this.$loading.show();
          this.$fetchql.Post("order/payconfirm", {
            verifycode: this.ct.join(''),
            token: this.payToken
          }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.isShowPassWordAlert = false;
              this.ct = ['', '', '', '', '', ''];
              this.payResultModal = true;
            }
          })
        } else {
          this.bindConfirm();
        }
      },
      //用户现有的绑卡是宝付的，手动调用易宝的绑卡功能
      bindConfirm() {
        this.$loading.show();
        this.$fetchql.Post("bankcard/bind/confirm", {
          verifycode: this.ct.join(''),
          requestno: this.bindBankNo
        }).then((result) => {
          this.$loading.hide();
          if (result.code == 0) {
            this.ct = ['', '', '', '', '', ''];
            this.isShowPassWordAlert = false;
          }
        });
      },
      //去支付
      goPay() {
        let that = this;
        if (!that.bankid) {
          if (!that.bankList.length) {
            this.$toast({
              message: '请先添加银行卡！'
            });
          }
          return
        }
        let paymentcreateData = {
          orderno: that.orderno,
          ordertype: that.type - 0,
          paychannel: 6,
          bankid: that.bankid - 0,
        };
        that.$loading.show();
        that.$fetchql.Get("pay/channel/v1").then((res) => {
          that.$loading.hide();
          //快捷支付银行卡支付：6宝付银行卡，8，易宝绑卡支付；15，有赞快捷支付
          if (res.data.bankpaychannel != 0) {
            paymentcreateData.paychannel = res.data.bankpaychannel
            that.$fetchql.Post("order/pay/v1", paymentcreateData).then((result) => {
              if (res.data.bankpaychannel == 8) {
                if (result.code == 0) {
                  //resulttype：1，把宝付的卡绑定到易宝渠道里；2，打开易宝支付弹窗，输入支付验证码
                  if (result.data.resulttype == 1) {
                    that.isBindOrPay = 'bind'
                    that.yzmTitle = '输入验证码';
                    that.payBtnText = '确认开户';
                    that.bindBankNo = result.data.resultdata
                  } else if (result.data.resulttype == 2) {
                    that.payToken = result.data.resultdata;
                    that.isBindOrPay = 'pay'
                    that.yzmTitle = '输入验证码';
                    that.payBtnText = '确认支付';
                  } else if (result.data.resulttype == 3) {
                    that.isBindOrPay = 'bind'
                    that.yzmTitle = '输入绑卡验证码';
                    that.payBtnText = '确认绑卡银行卡';
                    that.bindBankNo = result.data.resultdata
                  }
                  that.isShowPassWordAlert = true;
                }
              } else {
                if (result.code == 0) {
                  // flag标识：1，未设置支付密码，resulturl返回设置支付密码链接；2，resulturl支付链接
                  if (result.data.resulttype == 1) {
                    let data = {
                      source: that.source || "payment",
                      type: that.type,
                      orderno: that.orderno,
                      id: that.id,
                      status: that.status,
                    }
                    that.pwdmodalData = data
                    that.pwdUrl = result.data.resulturl
                    //未设置支付密码显示弹窗
                    that.pwdmodal = true;
                  } else if (result.data.resulttype == 2) {
                    // 去支付，拼接支付回调位置，支付完回到banklist页面
                    let orderdata = {
                      ordertype: that.type,
                      orderno: that.orderno,
                      id: that.id,
                      status: that.status,
                      source: that.source,
                    }
                    window.location.href = result.data.resulturl + "?Address=" +
                      location.origin + "/appBankList?orderdata=" + JSON
                      .stringify(orderdata)
                  } else if (result.data.resulttype == 3) {
                    that.isBindOrPay = 'bind'
                    that.yzmTitle = '输入绑卡验证码';
                    that.payBtnText = '确认绑卡银行卡';
                    that.bindBankNo = result.data.resultdata
                    that.isShowPassWordAlert = true;
                  }
                }
              }

            });
          }


        })



      },
      //添加银行卡
      addBank() {
        if (this.bankList.length < 5) {
          this.$router.push({
            path: "/appAddBank",
            query: {
              redirect: this.$route.fullPath
            }
          })
        } else {
          //"银行卡数量已达上限"
          this.$toast({
            message: this.$i18nn.t('bankList.bankUpper')
          })
        }
      },
      formatDateFn(t) {
        var d = Math.floor(t / 60 / 60 / 24);
        var h = Math.floor(t / 3600);
        var m = Math.floor((t - h * 3600) / 60);
        var s = Math.floor(t - h * 3600 - m * 60);
        var days = d >= 10 ? d : "0" + d;
        var hours = h >= 10 ? h : "0" + h;
        var minutes = m >= 10 ? m : "0" + m;
        var seconds = s >= 10 ? s : "0" + s;
        return minutes + ":" + seconds;
      },
      payCountDownFn(obj) {
        var currentTime = this.CURRENTTIME;
        var endTime = new Date(obj.payexpiretime).getTime();
        var time;
        if (endTime - currentTime > 0) {
          time = (endTime - currentTime) / 1000;
          // if (time > 300) time = 300;
        } else {
          time = 0;
        }

        this.timer = setInterval(() => {
          time--;
          console.log(time);
          var status = this.status;
          console.log(time, status);
          if (time <= 0) {
            clearInterval(this.timer);
            this.payCountDown = "00:00";
            if (status && status == 3) {
              this.showCountDown = false;
              if (this.type == 4) {
                //域名购买
                setTimeout(() => {
                  this.$router.replace({
                    path: "/searchList"
                  });
                }, 2000);

              } else {
                setTimeout(() => {
                  this.$router.push({
                    path: "/boxdetail",
                    query: {
                      id: this.id,
                    },
                  });
                }, 90000);
              }

              return;
            }

            console.log(status);
            this.$toast({
              message: this.$i18nn.t('bankList.orderTimeOut'), //"订单已超时，请重新下单",orderTimeOut
            });
            let data = {
              orderno: this.orderno,
              ordertype: Number(this.type),
              remark: '定时结束取消banklist页面',
            };

            // app 极速版专用
            this.$fetchql.Post("opus/goods/order/cancel", data, 'noMsg').then((result) => {
              if (result.code == 0) {
                clearInterval(this.timer);
                this.$router.push({
                  path: '/prodDetail',
                  query: {
                    id: this.$route.query.id
                  }
                })
              } else {
                this.$toast({
                  message: result.message,
                });
              }
            });


          } else {
            this.payCountDown = this.formatDateFn(time);
          }
        }, 1000);
      },
      //查询订单状态 封装接口 盲盒和作品同一个接口 传值不同
      orderStatus(orderType) {
        let that = this;
        that.$loading.show();
        that.payResultModal = false;
        that.payResultError++;
        that.$fetchql
          .Post("order/status", {
            orderType: orderType,
            orderNo: that.orderno
          })
          .then((res) => {
            if (res.code == 0) {
              // 返回订单状态 1.成功 2.失败 3.支付中
              if (res.data == 1) {
                window.clearInterval(int);
                window.clearInterval(int1);
                that.$loading.hide();
                setTimeout(function () {
                  if (that.source.indexOf('boheSuger') != -1) {
                    that.$router.replace({
                      path: "/rechargeSuccess",
                    });
                  } else {
                    that.$router.replace({
                      path: "/appOpenBox", // 如果在app内部，跳转到打开盲盒后的页面
                      query: {
                        orderno: that.orderno,
                        ordertype: orderType,
                      },
                    });
                  }

                }, 1000);
              } else if (res.data == 2) {
                window.clearInterval(int);
                window.clearInterval(int1);
                that.$loading.hide();
                that.$toast({
                  message: that.$i18nn.t('bankList.payError'), //"交易失败",payError
                });
                setTimeout(function () {
                  that.$router.replace({
                    path: "/",
                  });
                }, 2000);
              } else if (res.data == 3) {
                that.orderStatusSetTimeout = setTimeout(() => {
                  if (that.payResultError >= 3) {
                    that.$toast({
                      message: that.$i18nn.t('bankList.payError'), //"交易失败",
                    });
                    that.$loading.hide();
                  } else {
                    that.orderStatus(orderType);
                  }
                }, 3000)
                that.$loading.show();
              } else if (res.data == 0) {
                that.$loading.hide();
                that.payResultModal = false;
              }
            }

          })
      },
      // 获取盲盒活动银行卡见面规则
      getBankPaySaleData() {
        this.$fetchql.Post('pack/pay/discount/status', {
          id: this.$route.query.id * 1,
        }).then(res => {
          if (res.code != 0) return
          this.bankPaySaleObj = Object.assign(this.bankPaySaleObj, res.data);
        })
      },
      // 获取域名活动银行卡见面规则
      getBankPaySaleData2() {
        this.$fetchql.Post('domain/pay/discount/status', {}).then(res => {
          if (res.code != 0) return
          this.bankPaySaleObj = Object.assign(this.bankPaySaleObj, res.data);
        })
      },
      // 通过订单号查询相关信息 app 极速版
      getOrderInfoObjApp() {
        this.$fetchql.Post('opus/goods/order/info', {
          orderNo: this.$route.query.orderno || this.orderno,
        }).then(res => {
          if (res.code != 0) return
          if (this.source.indexOf('boheSuger') == -1) {
            res.data.payexpiretime = res.data.payExpireTime;
            this.payCountDownFn(res.data);
          }
          this.totalPrice = res.data.totalPrice;
        })
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
      clearTimeout(this.orderStatusSetTimeout);
      window.clearInterval(int);
      window.clearInterval(int1);
    },
    mounted() {
      let that = this;

      if (this.$route.query.type && this.$route.query.type == 4) {
        this.getBankPaySaleData2();
      } else {
        this.getBankPaySaleData();
      }

      document.addEventListener("visibilitychange", function () {
        if (document.hidden) {} else {
          if (that.$route.path.indexOf("bankList") != -1) {
            // that.$router.go(0);
          }
        }
      });
      if (that.$route.query.orderno) {
        that.orderno = that.$route.query.orderno
        that.source = that.$route.query.source
        that.type = that.$route.query.type
        that.id = that.$route.query.id
        that.status = that.$route.query.status
      }

      if (that.$route.query.backstring) {
        let data = JSON.parse(that.$route.query.backstring)
        that.orderno = data.orderno
        that.source = data.source
        that.type = data.type
        that.id = data.id
        that.status = data.status

      }
      //去 宝付后的回调
      if (that.$route.query.orderdata) {
        let data = JSON.parse(that.$route.query.orderdata)
        that.orderno = data.orderno;
        that.type = data.ordertype;
        that.source = data.source;
        that.id = data.id;
        that.status = data.status;

      }

      //app 极速版
      that.getOrderInfoObjApp()


      if (this.$route.query.orderdata) {
        this.payResultModal = true;
      }



    },
    created() {
      this.banklist()

      //判断是否在app内部打开
      let u = navigator.userAgent
      if (u.indexOf('mints') != -1) {
        this.isInApp = true;
        this.$bridge.callhandler("hideNavigationBar", {}, (res) => {})

        this.$bridge.callhandler("inApp", "周杰伦DEMO空间", (res) => {
          this.isInApp = res;
          if (this.isInApp) {
            this.$bridge.callhandler("getUserToken", {}, (token) => {
              if (token) {
                this.$store.setstate.token(token);
                this.banklist()
              } else {
                this.$store.setstate.token("");
                this.$bridge.callhandler("getLogin", {}, (token) => {});
              }
            });
          }
        });
      }
      this.$fetchql.Get("time/now").then((result) => {
        if (result.code == 0) {
          this.CURRENTTIME = new Date(result.data).getTime();
        } else {
          this.CURRENTTIME = Date.now();
        }
      })
    },

  }

</script>
<style scoped lang="less">
  .setPassAlertMask {
    position: fixed;
    z-index: 2;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);

    .passwordModel {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 281px;
      height: 195px;
      background: #333333;
      margin-left: -140.5px;
      margin-top: -97.5px;
      border-radius: 4px;
      text-align: center;

      .close {
        position: absolute;
        right: 12px;
        top: 13px;
        width: 26px;
        height: 26px;
        background: url('/static/img/give/close.png');
        background-size: 26px 26px;
      }

      p {
        margin: 0;
      }

      .pass-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        margin: 20px auto 25px;
      }

      .captcha {
        display: flex;
        justify-content: center;

        input {
          margin-right: 9px;
          width: 33px;
          height: 33px;
          text-align: center;
          border: none;
          outline: none;
          box-sizing: border-box;
          background: #383838;
          border-radius: 3px;
          color: #fff;
          font-size: 16px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
        }

        input:last-of-type {
          margin-right: 0;
        }

        input:disabled {
          // color: #000;
          // background-color: #fff;
        }
      }

      .modelBtn {
        width: 243px;
        height: 40px;
        background: url(/static/img/payment/modelBtn.png);
        background-size: 243px 40px;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #282828;
        line-height: 40px;
        margin: 30px auto;
        text-align: center;
      }

      .modelBtn1 {
        width: 243px;
        height: 40px;
        background: url(/static/img/payment/modelBtn1.png);
        background-size: 243px 40px;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: bold;
        color: #282828;
        line-height: 40px;
        margin: 30px auto;
        text-align: center;
      }
    }
  }

  .topHeader {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 9;
    height: 94px;
    background: #000;

    .backImg {
      width: 21px;
      height: 9px;
      display: inline-block;
      vertical-align: middle;
      position: absolute;
      left: 15px;
      top: 59px;
    }

    .title {
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      display: inline-block;
      width: 100%;
      margin-top: 56px;
    }

  }

  .payInfo {
    overflow: hidden;
    margin: 125px 25px 37px;
    width: 325px;
    text-align: center;
    padding-bottom: 47.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);

    .money {
      font-size: 15px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      font-weight: bold;
      color: #FFFFFF;

      span {
        font-size: 30px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
      }
    }

    .name {
      font-size: 12px;
      font-family: SourceHanSansCN-Light, SourceHanSansCN;
      font-weight: 300;
      color: #999999;
      margin-top: 15px;
    }


  }

  .bankListCon {
    padding: 0 25px;

    .title {
      font-size: 19px;
      font-family: SourceHanSansCN-Heavy, SourceHanSansCN;
      font-weight: 800;
      color: #FFFFFF;
      margin-top: 15px;
      margin-bottom: 15px;

      span {
        display: inline-block;
        vertical-align: middle;
      }

      .sale {
        vertical-align: middle;
        display: inline-block;
        background: #ffffff;
        padding: 2px 5px;
        border-radius: 3px 3px 3px 0;
        font-size: 10px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        color: #000000;
      }
    }

    .bankCon {

      .list {
        height: 50px;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        color: #FFFFFF;
        line-height: 50px;
        display: flex;
        align-items: center;

        .banklogo {
          width: 17px;
          height: 17px;
          vertical-align: middle;
          margin-right: 12px;
          margin-bottom: 3px;
        }

        .name {
          flex: 1;
        }

        .selectImg {
          width: 18px;
          height: 18px;
          vertical-align: middle;
        }

        .nextImg {
          width: 6px;
          height: 10px;
        }
      }

      .list:last-child {
        border-bottom: none;
      }
    }

    .time {
      padding-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #616466;
      text-align: center;

      span {
        color: #1CE89E;
        font-family: Semibold;
      }
    }

    .payment_btn {
      margin-top: 15px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: bold;
      color: #013925;
      line-height: 45px;
      letter-spacing: 1px;
      height: 45px;
      background-image: url(/static/img/payment/btn-on.png);
      background-size: 100% 100%;
      text-align: center;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/bankList.vue